<template>
  <div class="kefu">
    <transition name="fade">
      <div class="mask fixed" v-if="showTag" @click.stop="hide"></div>
    </transition>
    <transition name="fade">
      <div class="main fixed" @click.stop v-if="showTag">
        <a class="close iconfont absolute fs18" @click.stop="hide">&#xe61a;</a>

        <h3 class="center fs18">联系客服</h3>

        <div class="center fs16"><a href="tel:057187767077" class="iconfont fs30 color_main">&#xe67b; </a> 0571-87767077
        </div>

        <p class="center fs14">平台医助工作时间</p>

        <p class="center fs14">周一至周五</p>

        <p class="center fs14">上午 08:00-11:30</p>

        <p class="center fs14">下午 13:30-17:00</p>

      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'user-kefu',
  data() {
    return {
      showTag: false
    };
  },
  computed: {},
  components: {},
  mixins: [],
  created() {

  },
  mounted() {
    document.querySelector('body').appendChild(this.$el);
  },
  beforeDestroy() {

  },
  methods: {
    show() {
      this.showTag = true;
    },
    hide() {
      this.showTag = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/public";

.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  transform: translateY(100%);
  opacity: 0;
}

.mask {
  @include t_r_b_l();
  z-index: 10000;
  background-color: rgba(0, 0, 0, .5);
}

.main {
  top: 100px;
  left: 50px;
  right: 50px;
  z-index: 11000;
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: white;

  div, p {
    padding-top: 10px;
  }
}

.close {
  right: 10px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/user/kefu.vue